// extracted by mini-css-extract-plugin
export default {"wrapper":"text__wrapper__IN1ez","title":"text__title__xoqq8","body":"text__body__Z1qDp","img":"text__img__uMqyd"};